// extracted by mini-css-extract-plugin
export default {"elements":"styles_elements__jeC40"};